export class Group {
  id: string;
  name: string;
  roles: string[];

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.name = payload.name;
      this.roles = payload.roles;
    }
  }

  static createGroups(result: Array<any>): Group[] {
    const groups = new Array<Group>();
    if (result) {
      result.map((group) => {
        groups.push(new Group(group));
      });
    }
    return groups;
  }
}

export class GroupInput {
  id: string;
  name: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.name = payload.name;
    }
  }
}
